<template>
  <div class="comment-wrap">
    <h5 class="title">댓글<span class="count">({{comments.length}})</span></h5>
    <template v-if="logined">
    <form class="comment-form">
      <div class="textarea-wrap wid100p">
        <label for="comment-input" class="sr-only">댓글 작성</label>
        <textarea v-model.trim="content" id="comment-input" placeholder="댓글을 작성해주세요." rows="4" required title="댓글을 작성해주세요."></textarea>
        <button type="button" class="btn btn-gray btn-sm" @click="addComment">등록</button>
      </div>
    </form>
    </template>
    <template v-if="!logined">
    <div class="no-data pd-16">
      <p><a href="login.do">로그인</a>하시면 댓글쓰기를 할 수 있습니다.</p>
    </div>
    </template>

    <template v-if="comments.length != 0">
    <ul class="comment-list">
      <li class="comment-item" v-for="(comment, index) in comments" :key="index">
        <div class="comment-meta" :id="'info-view-layer-' + index" v-if="isMemberPost && getMntoName(comment.id) !== ''">
          <span class="user">{{getMntoName(comment.id)}}</span>
          <time datetime="2023.09.17 10:59:21">{{dateFormat(comment.createdDate)}}</time>
          <div class="btn-wrap">
            <button type="button" class="btn edit">수정</button>
            <span>|</span>
            <button type="button" class="btn delete" @click="delComment(comment.id)">삭제</button>
          </div>
        </div>
        <div class="comment-body">
          <p>
            {{comment.content}}
          </p>
          <div class="textarea-wrap wid100p hide">
            <button type="button" class="btn btn-gray btn-sm">저장</button>
          </div>
        </div>
      </li>
    </ul>
    </template>
  </div>
</template>
<script>
  import axios from 'axios';

  export default {
    name: 'post-comment',
    props: ['postId', 'isMemberPost', 'logined', 'photoUrl'],
    data() {
      return {
        comments: [],
        likes: [],
        me: [],
        content: '',
        progressing: false,
        loginid: null,
        mntoPrflList: [],
        postType: '',
      };
    },
    computed: {
      url() {
        return (this.isMemberPost) ? `/api/member-comments/${this.postId}` : `/api/comments/${this.postId}`;
      },
      commentLikeUrl() {
        return (this.isMemberPost) ? '/api/member-comments/like/' : '/api/comments/like/';
      },
      content_length() {
        if (this.content === null) {
          return 0;
        }
        return this.content.length;
      },
    },
    methods: {
      showMntPrfl(index) {
        $('.info-view-layer').css('display', 'none');
        $(`#info-view-layer-${index}`).css('display', 'block');
      },
      closeMntPrfl() {
        $('.info-view-layer').css('display', 'none');
      },
      getMntoName(id) {
        const result = this.mntoPrflList.find(item => item.postId === id);
        return (result) ? result.mntoName : '';
      },
      getMntoProfile(id) {
        let profile = [];
        const result = this.mntoPrflList.find(item => item.postId === id);
        if (result !== undefined && result.mntoProfile !== undefined) {
          profile = result.mntoProfile;
        }
        return profile;
      },
      dateFormat(date) {
        return `${date.slice(0, 4)}.${date.slice(5, 7)}.${date.slice(8)}`;
      },
      getCommentList() {
        axios.get(this.url).then((res) => {
          const result = res.data || [];
          this.comments = result.comments;
          this.likes = result.likes;
          this.me = result.me;
          this.loginid = result.loginid;
          if (this.isMemberPost) {
            this.postType = result.postType;
            if (this.postType === 'COUNSEL') {
              this.mntoPrflList = result.mntoPrflList;
            }
          }
        }).catch(e => console.log(e));
      },
      addComment() {
        if (this.progressing) return;
        if (!this.content) return;

        this.progressing = true;
        console.log(this.content);
        axios.post(this.url, { content: this.content }).then((res) => {
          const result = res.data || [];
          this.comments = result.comments;
          this.likes = result.likes;
          this.me = result.me;
          this.progressing = false;
          this.content = '';
        }).catch(() => alert('댓글을 달 수 없습니다.'));
      },
      delComment(id) {
        const delConfirm = window.confirm('정말 삭제하시겠습니까?');
        if (delConfirm) {
          axios.delete(`${this.url}/${id}`).then((res) => {
            const result = res.data || [];
            this.comments = result.comments;
            this.likes = result.likes;
            this.me = result.me;
            this.progressing = false;
            this.content = '';
          }).catch(() => alert('댓글을 삭제할 수 없습니다.'));
        }
      },
      getLikeCount(id) {
        const result = this.likes.find(item => item.id === id);
        return (result) ? result.count : 0;
      },
      isMyLike(id) {
        return this.me.includes(id);
      },
      getPhotoUrl(photoUrl) {
        return photoUrl || '/images/bg-my-default.png';
      },
      addLike(id) {
        if (this.me.includes(id)) return;
        if (this.progressing) return;

        this.progressing = true;
        axios.post(`${this.commentLikeUrl}${id}`).then((res) => {
          const index = this.likes.findIndex(item => item.id === id);
          if (index !== -1) this.likes.splice(index, 1);
          this.likes.push({
            id,
            count: res.data,
          });
          if (this.logined) this.me.push(id);
          this.progressing = false;
        }).catch(() => alert('좋아요를 할 수 없습니다.'));
      },
    },
    created() {
      this.getCommentList();
    },
  };
</script>
<style lang="scss" scoped>
  .del-seperator {
    margin: 0 10px;
  }
  .del-comment {
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// PostComment.vue?0d415ae9